import { model as sessionModel } from '$/session'
import { createEvent, sample } from 'effector'
import { dynamicModuleModel } from '~/widgets/DynamicModule'
import { appearanceFeature } from '~/features/appearance'

export const init = createEvent<{
  identifier: string
  query: URLSearchParams
}>()

export const left = createEvent()

sample({
  clock: init,
  fn: (params) => params.identifier,
  target: appearanceFeature.setIdentifier,
})

//
// rows
//

sample({
  clock: init,
  target: dynamicModuleModel.initModule,
})

sample({
  clock: left,
  source: appearanceFeature.$currentIdentifier,
  fn: (identifier) => (identifier ? { identifier } : { identifier: '' }),
  target: dynamicModuleModel.leaveModule,
})

sample({
  clock: sessionModel.$session,
  target: dynamicModuleModel.resetRows,
})
